import { compose } from 'recompose';
import api from '../../../../../api';
import { withData } from '../../../../hoc/withData';
import CompanyLink from './presenter';

export default compose(
    withData({
        resolve: {
            company: ({ companyId }) => api.company.getCompany(companyId),
        },
    })
)(CompanyLink);
